<template>
  <div class="overview-course">
    <p class="overview-course__title">{{ tableData.title }}</p>
    <ul>
      <li>
        <span class="overview-course__label">Название курса</span>
        <p class="overview-course__description">{{ tableData.title }}</p>
      </li>
      <li>
        <span class="overview-course__label">Модуль</span>
        <p class="overview-course__description">{{ tableData.module }}</p>
      </li>
      <li>
        <span class="overview-course__label">Минимальный порог входа</span>
        <p class="overview-course__description">{{ tableData.minScore }}</p>
      </li>
      <li>
        <span class="overview-course__label">Итоговый уровень</span>
        <p class="overview-course__description">{{ tableData.amountScore }}</p>
      </li>
      <li>
        <span class="overview-course__label">Статус</span>
        <p class="overview-course__description">{{ tableData.status }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OverviewCourse',
  props: {
    formModel: {
      type: Object,
      required: true
    },
    courseData: {
      type: Array,
      default: () => ({})
    }
  },
  data: () => ({
    tableData: {}
  }),
  mounted() {
    this.getCourseData()
  },
  methods: {
    getCourseData() {
      const routeIndex = +this.$route.params.id
      const { title, description, status, minScore, amountScore } = this.courseData[routeIndex]
      this.tableData = {
        title,
        module: description.join(', '),
        status,
        minScore,
        amountScore
      }
    }
  }
}
</script>

<style scoped lang="scss">
.overview-course {
  &__label {
    display: block;
    margin-bottom: 4px;
    padding-left: 6px;
    font-size: 12px;
    color: $french-gray;
  }

  &__description {
    margin-bottom: 16px;
    padding: 8px;
    border: 1px solid $whisper;
    border-radius: 4px;
  }

  &__title {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 24px;
    text-align: left;
    letter-spacing: 0.35px;
    color: $deepdark;

    @include sm-and-down {
      text-align: center;
    }
  }

  ul {
    max-width: 80%;

    @include sm-and-down {
      max-width: 100%;
    }
  }
}
</style>
